module.exports = __webpack_public_path__ + "static/media/survey.cee4b90e.svg";